/* src/app/components/game-layer/session-create-component/session-create-component.css */
.session-create-card .button-row {
  margin-top: 20px;
}
.session-create-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin: 22px 0;
}
.campaign-pick-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-top: 20px;
}
.session-description-field {
  margin-bottom: 22px;
}
.session-create-loader {
  margin: 16px 0;
}
.campaign-pick {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  background: transparent;
  color: inherit;
  text-align: left;
}
.campaign-pick:hover {
  border-color: rgba(212, 175, 55, 0.4);
}
.campaign-pick.is-selected {
  border-color: rgba(240, 215, 122, 0.78);
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.14);
}
.session-recap {
  margin-top: 28px;
  padding: 22px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--line);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.12),
      transparent 30%),
    linear-gradient(
      180deg,
      rgba(37, 26, 20, 0.9) 0%,
      rgba(24, 20, 18, 0.96) 100%);
}
.session-recap h3 {
  margin: 0 0 10px;
}
.session-recap-detail {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 18px 0;
  color: var(--ink);
}
.session-recap-description {
  align-items: flex-start;
  flex-direction: column;
}
.session-recap-description span {
  color: var(--ink-soft);
}
@media (max-width: 640px) {
  .campaign-pick-grid {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=session-create-component.css.map */
